import RequestAdapter from '../adapters/RequestAdapter';
import { API_V3_PATH_BASE } from '../constants';
import { ENDPOINTS } from '../enums/endpoints';

/**
 * Export SAF-T file
 *
 * @function
 *
 * @param {object} params
 *
 * @returns {object} JSON response
 */
const exportSAFT = async (params) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.SAFT.EXPORT}?${params}`,
    method: 'GET',
  };

  return await RequestAdapter.request(requestConfig);
};

const getYears = async () => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.SAFT.GET_YEARS}`,
    method: 'GET',
  };

  return await RequestAdapter.request(requestConfig);
};

const getScheduleSAFT = async () => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.SAFT.SCHEDULE}`,
    method: 'GET',
  };

  return await RequestAdapter.request(requestConfig);
};

const submitScheduleSAFT = async (formData) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.SAFT.SCHEDULE}`,
    method: 'POST',
    body: JSON.stringify({
      saft_schedule: formData,
    }),
  };

  return await RequestAdapter.request(requestConfig);
};

const updateScheduleSAFT = async (formData) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.SAFT.SCHEDULE}`,
    method: 'PUT',
    body: JSON.stringify({
      saft_schedule: formData,
    }),
  };

  return await RequestAdapter.request(requestConfig);
};

export const SAFTService = {
  exportSAFT,
  getYears,
  getScheduleSAFT,
  submitScheduleSAFT,
  updateScheduleSAFT,
};
